// TargetAudience.js
import React from 'react';
import { motion } from 'framer-motion';
import { Users, Briefcase, Heart } from 'lucide-react';

const TargetAudience = () => {
  const audiences = [
    {
      icon: Users,
      text: 'Students seeking undergraduate or postgraduate education abroad'
    },
    {
      icon: Briefcase,
      text: 'Professionals pursuing further education to advance their careers'
    },
    {
      icon: Heart,
      text: 'Parents supporting their children with international education plans'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {/* Left Side - Heading */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356]">
              Who This Service Is For
            </h2>
          </motion.div>
          
          {/* Right Side - Content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <p className="text-gray-600 text-sm font-light leading-relaxed mb-6">
              Our Study Abroad support is designed for:
            </p>
            
            <div className="space-y-4 mb-6">
              {audiences.map((audience, index) => {
                const Icon = audience.icon;
                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.2 + (index * 0.1) }}
                    className="flex items-start gap-3"
                  >
                    <Icon size={20} className="text-gray-600 flex-shrink-0 mt-0.5" />
                    <span className="text-gray-600 text-sm font-light">{audience.text}</span>
                  </motion.div>
                );
              })}
            </div>
            
            <p className="text-gray-600 text-sm font-light leading-relaxed">
              If you are unsure where to begin or which option is right for you, our consultation process helps clarify your pathway.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
